import React, { Fragment, useState, useEffect } from "react";
import { withRouter, Link } from "react-router-dom";
import axios from "axios";

const AdminVotacion = (props) => {
  const municipio = props.municipio;
  const [votacion, guardarVotacion] = useState(undefined);
  const [error, guardarError] = useState(false);

  useEffect(() => {
    const obtenerVotacion = () => {
      axios
        .get(`/api/votaciones/${municipio._id}`)
        .then((res) => {
          guardarVotacion(res.data.votacion[0]);
        })
        .catch((error) => guardarError(true));
    };
    obtenerVotacion();
    return () => {
      guardarVotacion(undefined);
    };
  }, [municipio._id]);

  if (votacion === undefined || municipio?.etapa === "presentacion" || error)
    return null;

  console.log(votacion);

  return (
    <Fragment>
      <div className="row">
        <div className="col-md-12">
          <h4 className="ppr-titulo centrado my-2">Administrar Votación</h4>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6 mx-auto">
          <center>
            <p>
              <b>Votos por propuesta</b>
            </p>
            {Object.entries(votacion.votosXPropuesta).map((infoPropuesta) => (
              <p key={infoPropuesta[0]}>
                {votacion.titulosPropuestas[infoPropuesta[0]]} :
                {infoPropuesta[1]}
              </p>
            ))}
          </center>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 mx-auto">
          <center>
            <br></br>
            <p>Votos Totales: {votacion.aceptados + votacion.anulados}</p>
            <p>Votos Aceptados: {votacion.aceptados}</p>
            <p>Votos Anulados: {votacion.anulados}</p>

            <Link
              to={"/consola/fiscalizar"}
              className="btn ppr-btn-azul font-weight-bold m-2"
            >
              Fiscalizar Votación
            </Link>
          </center>
        </div>
      </div>
    </Fragment>
  );
};

export default withRouter(AdminVotacion);
